import { ga4Push } from '../../../ga4/ga4-utilities';
import Localization from '../../../other/localization';
import { GrecaptchaV2 } from '../../../other/grecaptcha/grecaptcha-v2';
import AbstractValidator from '../abstract-validator';
import AbstractValidatorOptions from '../abstract-validator-options';

/**
 * Login form validation module.
 *
 * @author Kovács Tamás
 * @returns Login form validation module
 */
function LoginForm() {
    const formId = 'loginForm';
    const formObject = $(`#${formId}`);
    const validator = AbstractValidator(formId);
    const validatorOptions = AbstractValidatorOptions();
    const messageBox = formObject.find('.js-message-box');
    const localization = new Localization();
    const greCaptchaV2 = new GrecaptchaV2();

    function addLoginBtnLoaders() {
        formObject.find('.login-btn').on('click.loginBtnClick', (event) => {
            $(event.currentTarget).addClass('button-loading disabled');
        });
    }

    function init() {
        addLoginBtnLoaders();
        validatorOptions.focusInvalid = false;
        validatorOptions.showToastMessages = false;
        validatorOptions.scrollToFirstError = false;
        validatorOptions.errorContainer = messageBox;
        validatorOptions.messages = {
            email: {
                required: (
                    localization
                    .getMessage('validation-message-email-required')
                ),
            },
            password: {
                required: (
                    localization
                    .getMessage('validation-message-password-required')
                ),
            },
        };

        validator.init(
            {
                email: {
                    maxlength: 60,
                    required: true,
                    customEmail: true,
                },
                password: {
                    maxlength: 60,
                    minlength: 8,
                    required: true,
                },
            },
            validatorOptions,
        );

        greCaptchaV2.init('loginCaptcha');

        formObject
        .on('succes', () => {
            ga4Push({
                event: 'userLogin',
            });
        })
        .on('error invalidForm', () => {
            greCaptchaV2.reset();
        })
        .on(
            'hidden.bs.modal',
            () => {
                greCaptchaV2.reset();
                formObject.validate().resetForm();
            },
        );
    }

    return {
        init,
    };
}

export default LoginForm;
